var map = {
	"./en.json": [
		2595,
		"src_app_cws2_0_tax-deduction-certificate_assets_i18n_en_json"
	],
	"./ja.json": [
		4057,
		"src_app_cws2_0_tax-deduction-certificate_assets_i18n_ja_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73469;
module.exports = webpackAsyncContext;